import React from 'react';
import Skeleton from 'react-loading-skeleton';

const TaskNotificationsSkeleton = () => {
    return (
        <>
            <div className='px-4'>
                <div className='flex items-center gap-2 w-full pb-1'>
                    <div>
                        <Skeleton circle height={44} width={44} />
                    </div>
                    <div>
                        <div className='mt-1.5'>
                            <Skeleton height={16} width={100} borderRadius={4} />
                            <div className='mt-0.5' >
                                <Skeleton height={14} width={200} borderRadius={4} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TaskNotificationsSkeleton;